import { render, staticRenderFns } from "./judicial.vue?vue&type=template&id=27628632"
import script from "./judicial.vue?vue&type=script&lang=js"
export * from "./judicial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports